<template>
  <div></div>
</template>

<script>
import { createPrismPoint } from "../../utils/bimface";
import Color from "color";

export default {
  name: "PrismPoint",
  props: {
    x: Number | String,
    y: Number | String,
    z: Number | String,
    position: Object,
    size: Number,
    color: [String, Array],
    duration: Number,
    wireframeColor: Array,
    show: {
      type: Boolean,
      default: true,
    },
    play: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      instance: null,
      anchorMng: null,
    };
  },
  inject: ["bimface"],
  watch: {
    show(newVal) {
      this.showOrHide(newVal);
    },
    x(newVal) {
      this.updateX(newVal);
    },
    y(newVal) {
      this.updateY(newVal);
    },
    z(newVal) {
      this.updateZ(newVal);
    },
    position(newVal) {
      this.updatePosition(newVal);
    },
    size(newVal) {
      this.updateSize(newVal);
    },
    duration(newVal) {
      this.updateDuration(newVal);
    },
    play(newVal) {
      this.playOrPause(newVal);
    },
    "bimface.anchorMng": function (newVal) {
      this.init(newVal);
    },
  },
  methods: {
    init(anchorMng) {
      this.anchorMng = anchorMng;
      let color = Color(this.color);
      this.instance = createPrismPoint(
        this.getPosition(),
        this.size,
        [...color.rgb().array(), color.alpha()],
        this.duration
      );
      if (this.play !== undefined && !this.play) this.playOrPause(this.play);
      this.instance.onClick(() =>
        this.$emit("click", this.instance, this.anchorMng)
      );
      anchorMng.addItem(this.instance);
      this.showOrHide(this.show);
    },
    updateX(x) {
      this.instance &&
        this.instance.setPosition({ ...this.instance.getPosition(), x });
    },
    updateY(y) {
      this.instance &&
        this.instance.setPosition({ ...this.instance.getPosition(), y });
    },
    updateZ(z) {
      this.instance &&
        this.instance.setPosition({ ...this.instance.getPosition(), z });
    },
    updatePosition(position) {
      this.instance && this.instance.setPosition(position);
    },
    updateSize(size) {
      this.instance && this.instance.setSize(size);
    },
    updateDuration(duration) {
      this.instance && this.instance.setDuration(duration);
    },
    showOrHide(state) {
      state
        ? this.anchorMng.showItemsById([this.instance.id])
        : this.anchorMng.hideItemsById([this.instance.id]);
    },
    playOrPause(state) {
      state ? this.instance.play() : this.instance.pause();
    },
    getPosition() {
      return this.position === undefined
        ? {
            x: this.x || 0,
            y: this.y || 0,
            z: this.z || 0,
          }
        : this.position;
    },
    isAnchor() {
      return true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
